import { apiFetch } from "./api";
import { DashboardStats } from "../types/fyo";

export function fetchDashboard(): Promise<DashboardStats> {
  return apiFetch("/dashboard");
}
